module.exports = __webpack_public_path__ + "media/images/vod_icons/stride-96b20bef58e670cb3fd3baa611d5a665.svg";